import { z } from "zod";

// Prices are typed as text so a half-typed "0.0" isn't coerced away; they're
// parsed to numbers in the dialog before the API call.
const price = (label: string) =>
  z
    .string()
    .min(1, `${label} price is required`)
    .refine((v) => Number.isFinite(Number(v)) && Number(v) >= 0, "Enter a price of 0 or more");

export const metaRateFormSchema = z.object({
  country: z
    .string()
    .regex(/^([A-Za-z]{2}|\*)$/, "Use a two-letter country code, or * for every other country"),
  effectiveFrom: z.string().min(1, "Pick the date these prices start"),
  marketing: price("Marketing"),
  utility: price("Utility"),
  authentication: price("Authentication"),
  service: z
    .string()
    .optional()
    .refine(
      (v) => !v || (Number.isFinite(Number(v)) && Number(v) >= 0),
      "Enter a price of 0 or more"
    ),
  label: z.string().optional()
});

export type MetaRateFormData = z.infer<typeof metaRateFormSchema>;
